import { render, staticRenderFns } from "./InternalTransferForm.vue?vue&type=template&id=23551b7c&scoped=true"
import script from "./InternalTransferForm.vue?vue&type=script&lang=js"
export * from "./InternalTransferForm.vue?vue&type=script&lang=js"
import style0 from "./InternalTransferForm.vue?vue&type=style&index=0&id=23551b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23551b7c",
  null
  
)

export default component.exports